/*************************************************/
/* 3rd Party                                     */
/*************************************************/
window.$ = window.jQuery = require("jquery");

if (typeof window.document.documentMode == 'undefined') {
    // Passive event listeners
    window.$.event.special.touchstart = {
        setup: function (_, ns, handle) {
            this.addEventListener("touchstart", handle, { passive: !ns.includes("noPreventDefault") });
        }
    };
    window.$.event.special.touchmove = {
        setup: function (_, ns, handle) {
            this.addEventListener("touchmove", handle, { passive: !ns.includes("noPreventDefault") });
        }
    };
}

import { ieFixes } from "./tooling/ie-fixes.js";
import { mmenu } from "./partials/mmenu.js";
import { inview } from "./partials/inview.js";

/*************************************************/
/* Partials                                      */
/*************************************************/

import { header } from "./partials/header.js";
import { searchbar } from "./partials/searchbar.js";

/*************************************************/
/* Init                                          */
/*************************************************/
$(document).ready(function () {
    const $body = $("body");

    ieFixes();
    mmenu();
    inview();
    header($body);
    searchbar($body);
});